"use client";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { useTranslation } from "react-i18next";

const ComplianceSection = () => {
  const { t } = useTranslation();
  const items = t("compliance.items", { returnObjects: true }) as string[];

  return (
    <section id="compliance" className="py-20 md:py-28 bg-navy text-navy-foreground">
      <div className="container mx-auto px-4 md:px-8">
        <div className="max-w-3xl mx-auto">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.5 }}
            className="font-display text-3xl md:text-4xl font-bold tracking-tight mb-12 text-center"
          >
            {t("compliance.title")}
          </motion.h2>
          <div className="grid sm:grid-cols-2 gap-x-12 gap-y-5 max-w-2xl mx-auto">
            {items.map((item, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, x: -16 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.4, delay: i * 0.08 }}
                className="flex items-start gap-3"
              >
                <div className="mt-0.5 w-5 h-5 rounded-full bg-trust/20 flex items-center justify-center flex-shrink-0">
                  <Check className="h-3 w-3 text-trust" />
                </div>
                <span className="text-sm leading-relaxed opacity-90">{String(item)}</span>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComplianceSection;
